import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, createBlock as _createBlock, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/img/icon/edit-outline-blugrey.svg'
import _imports_1 from '@/assets/img/icon/dollar-outline-blue.svg'
import _imports_2 from '@/assets/img/icon/calendar-outline-yellow.svg'
import _imports_3 from '@/assets/img/icon/list-outline-green.svg'


const _hoisted_1 = { class: "verpal-detail" }
const _hoisted_2 = { class: "px-4 py-4" }
const _hoisted_3 = { class: "lg:flex items-center gap-4" }
const _hoisted_4 = {
  class: "header p-4 rounded-md",
  style: {"background-color":"#EFF5FF"}
}
const _hoisted_5 = { class: "flex w-full justify-between mb-3 items-start md:items-center gap-4" }
const _hoisted_6 = { class: "font-bold break-all md:break-normal" }
const _hoisted_7 = { class: "flex gap-8 items-center" }
const _hoisted_8 = { class: "block md:flex gap-4 mb-2 items-center" }
const _hoisted_9 = { class: "flex items-center gap-1 mb-1" }
const _hoisted_10 = { class: "text-grey-5 font-bold text-sm" }
const _hoisted_11 = { class: "block sm:flex gap-4 items-center" }
const _hoisted_12 = { class: "flex items-center gap-1" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user text-sm font-bold" }, null, -1)
const _hoisted_14 = { class: "text-grey text-sm font-bold" }
const _hoisted_15 = {
  key: 0,
  class: "flex items-center gap-1"
}
const _hoisted_16 = { class: "text-grey text-sm font-bold" }
const _hoisted_17 = { class: "flex items-center gap-1" }
const _hoisted_18 = { class: "text-grey text-sm font-bold" }
const _hoisted_19 = {
  class: "flex items-center pl-3",
  style: {"border-left":"2px solid #90A4AE"}
}
const _hoisted_20 = { class: "text-grey text-sm font-bold" }
const _hoisted_21 = {
  key: 0,
  class: "w-full mt-4 lg:w-1/4 lg:mt-0"
}
const _hoisted_22 = {
  class: "header p-4 rounded-md",
  style: {"background-color":"#EBEFF4"}
}
const _hoisted_23 = { class: "flex items-center justify-between mb-3" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-bold" }, "Detail Denda Verbal", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "edit"
}, null, -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { class: "grid grid-cols-2 gap-4 mb-1" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-2" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "total"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-grey" }, "Jumlah")
], -1)
const _hoisted_29 = { class: "font-bold" }
const _hoisted_30 = { class: "grid grid-cols-2 gap-4 mb-1" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-2" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "expdate"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-grey" }, "Jatuh Tempo")
], -1)
const _hoisted_32 = { class: "font-bold" }
const _hoisted_33 = { class: "grid grid-cols-2 gap-4 mb-1" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-2" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: "note"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-grey" }, "Keterangan")
], -1)
const _hoisted_35 = { class: "font-bold" }
const _hoisted_36 = { class: "grid grid-cols-1 md:grid-cols-2 mt-5 gap-6" }
const _hoisted_37 = { class: "mb-4" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", { class: "text-neutral-500 font-extrabold text-sm mb-2" }, "Perihal Laporan", -1)
const _hoisted_39 = { class: "font-semibold" }
const _hoisted_40 = { class: "mb-4" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("p", { class: "text-neutral-500 font-extrabold text-sm mb-2" }, "Kategori Laporan", -1)
const _hoisted_42 = { class: "flex gap-2 flex-wrap" }
const _hoisted_43 = { class: "mb-4" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("p", { class: "text-neutral-500 font-extrabold text-sm mb-2" }, "Bukti Tiket", -1)
const _hoisted_45 = { class: "flex items-center flex-wrap gap-2" }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = /*#__PURE__*/_createElementVNode("p", { class: "text-neutral-500 font-extrabold text-sm mb-2" }, "Kota Kejadian", -1)
const _hoisted_48 = { class: "font-semibold" }
const _hoisted_49 = { class: "mb-4" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("p", { class: "text-neutral-500 font-extrabold text-sm mb-2" }, "Keterangan Pelaporan", -1)
const _hoisted_51 = { class: "font-semibold mb-2" }
const _hoisted_52 = { class: "grid grid-cols-4 gap-4" }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = { class: "text-sm font-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatusVerbalChip = _resolveComponent("StatusVerbalChip")!
  const _component_InlineSvg = _resolveComponent("InlineSvg")!
  const _component_Chip = _resolveComponent("Chip")!
  const _component_SilentBoxSingle = _resolveComponent("SilentBoxSingle")!
  const _component_Card = _resolveComponent("Card")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_FineForm = _resolveComponent("FineForm")!
  const _component_HjpSideBar = _resolveComponent("HjpSideBar")!
  const _component_HjpCofirmModal = _resolveComponent("HjpCofirmModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Card, { class: "card-no-shadow" }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.dataDetail?.MsStatus?.Code === _ctx.StatusVerbal.Penalty ? 'w-full lg:w-3/4' : 'w-full')
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.dataDetail?.Controller.Rit.TransactionPp.RosterCode), 1),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_StatusVerbalChip, {
                      status: (_ctx.dataDetail?.MsStatus?.Name as StatusVerbal),
                      code: (_ctx.dataDetail?.MsStatus?.Code as StatusVerbalCode)
                    }, null, 8, ["status", "code"]),
                    _createElementVNode("i", {
                      class: "pi pi-ellipsis-h cursor-pointer text-xl font-extrabold",
                      style: {"color":"#000000"},
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDropDown($event)))
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_InlineSvg, {
                      src: require('@/assets/img/icon/arrow-circle-right-outline-blue.svg')
                    }, null, 8, ["src"]),
                    _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.dataDetail?.Controller.Rit.RouteName), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.dataDetail?.Controller?.Rit?.TransactionPp?.CondecturName), 1)
                  ]),
                  (_ctx.dataDetail?.Controller.Rit?.DriverName)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createVNode(_component_InlineSvg, {
                          src: require('@/assets/img/icon/steering-wheel.svg')
                        }, null, 8, ["src"]),
                        _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.dataDetail?.Controller.Rit?.DriverName), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_InlineSvg, {
                      src: require('@/assets/img/icon/truck-outline-black.svg')
                    }, null, 8, ["src"]),
                    _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.dataDetail?.Controller.Rit.TransactionPp.VehicleRegNumber), 1)
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("p", _hoisted_20, "Kontroller: " + _toDisplayString(_ctx.dataDetail?.Controller?.ControllerName), 1)
                  ])
                ])
              ])
            ], 2),
            (_ctx.dataDetail?.MsStatus?.Code === _ctx.StatusVerbal.Penalty)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _hoisted_24,
                      _createElementVNode("div", {
                        class: "cursor-pointer",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showForm()))
                      }, _hoisted_26)
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _hoisted_28,
                      _createElementVNode("div", _hoisted_29, _toDisplayString(`: ${_ctx.currencyNumberFormat(_ctx.dataDetail?.Penalty)}`), 1)
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _hoisted_31,
                      _createElementVNode("div", _hoisted_32, _toDisplayString(`: ${_ctx.dataDetail?.PenaltyDueDate === null ? '-' :
                    _ctx.moment(_ctx.dataDetail?.PenaltyDueDate.toString()).format('DD/MM/YYYY')}`), 1)
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _hoisted_34,
                      _createElementVNode("div", _hoisted_35, _toDisplayString(`: ${_ctx.dataDetail?.PenaltyDescription}`), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.dataDetail?.Verbatim), 1)
              ]),
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _createElementVNode("div", _hoisted_42, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataDetail?.VerbalConstraints, (constrain, idx) => {
                    return (_openBlock(), _createBlock(_component_Chip, _mergeProps({ key: idx }, {
                    text: constrain.ConstraintName,
                    style: {
                      color: '#2C8AFF',
                      backgroundColor: '#EFF5FF'
                    }
                  }), null, 16))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _hoisted_44,
                _createElementVNode("div", _hoisted_45, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataDetail?.TicketRevision, (data) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: data,
                      class: "font-semibold cursor-pointer border rounded-lg px-3 py-1 text-sm",
                      style: {"color":"#2C8AFF","border-color":"#2C8AFF","background-color":"#EFF5FF"},
                      onClick: ($event: any) => (_ctx.showTicket(data.Id))
                    }, _toDisplayString(data.Code), 9, _hoisted_46))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_47,
                _createElementVNode("p", _hoisted_48, _toDisplayString(_ctx.dataDetail?.VerbalStationName), 1)
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_49, [
                _hoisted_50,
                _createElementVNode("p", _hoisted_51, _toDisplayString(_ctx.dataDetail?.Verbatim), 1),
                _createElementVNode("div", _hoisted_52, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataDetail?.VerbalFiles, (img, idx) => {
                    return (_openBlock(), _createBlock(_component_SilentBoxSingle, {
                      key: idx,
                      image: img
                    }, null, 8, ["image"]))
                  }), 128))
                ])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_OverlayPanel, { ref: "refOpStatus" }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listStatus.filter((val) => val.label !== _ctx.dataDetail?.MsStatus?.Name), (item, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "flex mb-2 items-center gap-2 cursor-pointer",
              key: idx,
              onClick: ($event: any) => (_ctx.processChangeStatus(item))
            }, [
              _createElementVNode("div", {
                class: "flex rounded-full w-2 h-2",
                style: _normalizeStyle({ backgroundColor: item.color })
              }, null, 4),
              _createElementVNode("p", _hoisted_54, _toDisplayString(item.label), 1)
            ], 8, _hoisted_53))
          }), 128))
        ])
      ]),
      _: 1
    }, 512),
    (_ctx.isShowForm)
      ? (_openBlock(), _createBlock(_component_HjpSideBar, {
          key: 0,
          show: _ctx.isShowForm
        }, {
          form: _withCtx(() => [
            _createVNode(_component_FineForm, {
              dataDetail: _ctx.dataDetail,
              onOnReload: _ctx.reloadData
            }, null, 8, ["dataDetail", "onOnReload"])
          ]),
          _: 1
        }, 8, ["show"]))
      : _createCommentVNode("", true),
    _createVNode(_component_HjpCofirmModal, {
      show: _ctx.attrModalConfirmation.show,
      imgContent: _ctx.attrModalConfirmation.imgContent,
      title: _ctx.attrModalConfirmation.title,
      subTitle: _ctx.attrModalConfirmation.subTitle,
      btnSubmitTitle: _ctx.attrModalConfirmation.btnSubmitTitle,
      onHideDialog: _ctx.hideDialogConfirmation
    }, null, 8, ["show", "imgContent", "title", "subTitle", "btnSubmitTitle", "onHideDialog"])
  ]))
}